import React from 'react';
import { KanbanTask } from '../../stores/KanbanTaskStores';
import { Avatar, Tag} from 'antd';
import { Calendar, User } from 'lucide-react';
import { getPlainTextFromEditorData, getPriorityIcon, getPriorityColor, getPriorityText, formatDate, getTimeRemaining } from './useTaskHelpers';
import { useStore } from '../../stores/root-store-context';

const TaskCard: React.FC<{
  task: KanbanTask;
  onTaskClick: (task: KanbanTask) => void;
  handleDragStart: (e: React.DragEvent<HTMLDivElement>, task: KanbanTask) => void;
  handleDragEnd: () => void;
  cardRef: (el: HTMLDivElement | null) => void;
  t: (key: string) => string;
}> = ({ task, onTaskClick, handleDragStart, handleDragEnd, cardRef, t }) => {
  const timeRemaining = task.dueDate ? getTimeRemaining(task.dueDate?.toString(), t) : null;
  const {applicationStore} = useStore();

  const preview =
    (task.summary && task.summary.trim().length > 0
      ? task.summary.trim()
      : getPlainTextFromEditorData(task.description)
    ).slice(0, 100);

  return (
    <div
      ref={cardRef}
      draggable
      onDragStart={(e) => handleDragStart(e, task)}
      onDragEnd={handleDragEnd}
      onClick={() => onTaskClick(task)}
      className="task-card hover-effect kanban-cards"
    >
      <div className="task-card-content">
        <div className="task-card-header">
          {task.publicId && (
            <span className="task-card-public-id">{task.publicId.toUpperCase()}</span>
          )}
          <span className="task-card-title">{task.title}</span>
          <div className="task-card-priority">
            {getPriorityIcon(task.priority)}
          </div>
        </div>

        <p className="task-card-description">
          {preview}
        </p>

        <div className="task-card-footer">
          <div className="task-card-metadata">
            {task.dueDate && (
              <div className="task-card-due-date">
                <Calendar size={12} className="task-card-icon" />
                <span>{formatDate(task.dueDate?.toString())}</span>
                {timeRemaining && (
                  <Tag
                    color={timeRemaining.color}
                    className="task-card-tag"
                  >
                    {timeRemaining.text}
                  </Tag>
                )}
              </div>
            )}
          </div>

          {task.assignee ? (
            <div className="task-card-assignee">
              <Avatar
                size="small"
                className="task-card-avatar"
                src={
                  task.assignee.photoId
                    ? `${applicationStore?.siteConfig?.baseCloudinary}/image/upload/w_300/${task.assignee.photoId}`
                    : undefined
                }
              >
                {task.assignee.firstName?.[0]}
                {task.assignee.lastName?.[0]}
              </Avatar>
            </div>
          ) : (
            <div className="task-card-unassigned">
              <User size={14} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskCard;
